import { useEffect, useRef, useState } from 'react';

interface CtaSectionProps {
  onContactClick: () => void;
}

export default function CtaSection({ onContactClick }: CtaSectionProps) {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 relative overflow-hidden" style={{ background: '#0A508C' }}>
      <div className="absolute inset-0" style={{ background: 'linear-gradient(135deg, #0A508C 0%, #3A7CC0 50%, #2BC0D0 100%)' }} />
      
      {/* Background Image */}
      <div className="absolute inset-0 opacity-15">
        <img
          src="https://public.readdy.ai/ai/img_res/81eedf9a3c1bfc6e4d9369ac42547c97.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          {/* Left Text */}
          <div>
            <div className="text-sm font-bold uppercase tracking-widest mb-4 text-white/60">GET STARTED</div>
            <h2 className="text-5xl font-light text-white leading-tight mb-2">패키지 준비,</h2>
            <h2 className="text-5xl font-black text-white leading-tight mb-6">
              지금 바로<br />시작하세요
            </h2>
            <p className="text-white/70 text-base leading-relaxed mb-8">
              출하 일정에 맞춘 빠른 상담과 견적을 받아보세요.<br />
              신진패키징이 처음부터 끝까지 함께합니다.
            </p>
            {/* Contact Info */}
            <div className="flex flex-col gap-3">
              {[
                { icon: 'ri-phone-line', text: '010-7702-3283', href: 'tel:01077023283' },
                { icon: 'ri-mail-line', text: 'clxk0711@gmail.com', href: 'mailto:clxk0711@gmail.com' },
                { icon: 'ri-map-pin-line', text: '경기 성남시 분당구 서현동 249-3 6층', href: '#' },
              ].map((c) => (
                <a
                  key={c.text}
                  href={c.href}
                  rel="nofollow"
                  className="flex items-center gap-2.5 text-white/80 text-base hover:text-white transition-colors cursor-pointer"
                >
                  <i className={`${c.icon} text-[#70C6A3] text-lg`} />
                  {c.text}
                </a>
              ))}
            </div>
          </div>

          {/* Right Buttons */}
          <div className="flex flex-col gap-4">
            <div className="p-8 rounded-2xl" style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)' }}>
              <h3 className="text-white font-black text-xl mb-2">스마트스토어에서 바로 구매</h3>
              <p className="text-white/60 text-base mb-5">팩 제품을 지금 바로 주문할 수 있습니다</p>
              <a
                href="https://smartstore.naver.com"
                target="_blank"
                rel="nofollow noreferrer"
                className="w-full flex items-center justify-center gap-2 py-3.5 bg-white rounded-xl font-bold text-base cursor-pointer whitespace-nowrap transition-opacity hover:opacity-90"
                style={{ color: '#0A508C' }}
              >
                <i className="ri-store-2-line" />
                스마트스토어 가기
                <i className="ri-external-link-line text-base" />
              </a>
            </div>

            <div className="p-8 rounded-2xl" style={{ background: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)' }}>
              <h3 className="text-white font-black text-xl mb-2">맞춤 상담 문의</h3>
              <p className="text-white/60 text-base mb-5">라벨 디자인, 대량 주문 등 맞춤 견적 문의</p>
              <button
                onClick={onContactClick}
                className="w-full flex items-center justify-center gap-2 py-3.5 rounded-xl font-bold text-base cursor-pointer whitespace-nowrap border-2 border-white/50 text-white hover:bg-white/10 transition-colors"
              >
                <i className="ri-chat-3-line" />
                문의하기
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
